import React from 'react';
import {
  Box,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TextField,
  Radio,
  RadioGroup,
  FormControlLabel,
  Typography,
} from '@mui/material';
import { VoucherFormat } from '../types';
import NewGeneralSettingAC from '../../../pages/NewFigma/GeneralSettings/newGeneralSettingAc';

interface Props {
  newFYData: {
    financialyearid: number;
    startyear: number;
    endyear: number;
  };
}

export const VoucherNumberStep: React.FC<Props> = ({ newFYData }) => {
  return (
    <Box sx={{display: 'flex', flex:1}}>
      <NewGeneralSettingAC newFyId={newFYData} />
    </Box>
  );
};
